import { hasCompatibleSafariVersion } from './hasCompatibleSafariVersion'

/**
 * Compatibility measures for some CSS properties in Safari.
 * If the user is using Safari and the version is lower than 15, add the class 'safari-lower-than-15' to the document.
 */
export const cssPolyfill = (): void => {
  if (
    hasCompatibleSafariVersion(navigator.userAgent, {
      comparisonOperator: 'lower',
      version: 15,
    })
  ) {
    document.documentElement.classList.add('safari-lower-than-15')
  }
  if (
    hasCompatibleSafariVersion(navigator.userAgent, {
      comparisonOperator: 'lower',
      version: 16,
    })
  ) {
    document.documentElement.classList.add('safari-lower-than-16')
  }
}
